"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Section = _styledComponents.default.section(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n"])), function (props) {
  return props.colorMode === 'dark' ? 'white' : 'inherit';
}, function (props) {
  if (props.backgroundColor) {
    return props.backgroundColor;
  }

  return props.colorMode === 'dark' ? 'black' : 'transparent';
});

exports.Section = Section;